import React from 'react';
import { TextField } from 'new/elements/TextField';
import { InputProps as StandardInputProps } from '@mui/material/Input/Input';

import styles from './styles.module.scss';

type Props = {
  name: string;
  description: string;
  onChange: (change: { property: string; value: string }) => void;
};

export function MetaInfoInputForm({ name, description, onChange }: Props) {
  const _onChange: StandardInputProps['onChange'] = (event) => {
    if (typeof onChange === 'function') {
      onChange({ property: event.target.name, value: event.target.value });
    } else {
      console.error('onChange must be a function');
    }
  };

  const _name = name ?? '';
  const _description = description ?? '';

  return (
    <div className={styles.name_description_container}>
      <div className={styles.input_column}>
        <label className={styles.input_label_name}>Name</label>
        <TextField
          name="name"
          value={_name}
          placeholder="Enter a name"
          onChange={_onChange as any}
        />
      </div>
      <div className={styles.input_column}>
        <label className={styles.input_label_name}>Description</label>
        <TextField
          name="description"
          value={_description}
          placeholder="Enter a description"
          onChange={_onChange as any}
        />
      </div>
    </div>
  );
}
